var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';

export var PasswordStrength = function (_React$Component) {
  _inherits(PasswordStrength, _React$Component);

  function PasswordStrength() {
    var _temp, _this, _ret;

    _classCallCheck(this, PasswordStrength);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      color: '',
      suggestions: '',
      text: '',
      warning: '',
      score: ''
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  PasswordStrength.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.handleInput();
  };

  PasswordStrength.prototype.handleInput = function handleInput() {
    if (!window.hasOwnProperty('zxcvbn')) return false;

    var defaultStrength = {
      0: {
        color: '#f00',
        text: ''
      },
      1: {
        color: '#f71',
        text: ''
      },
      2: {
        color: '#00a5a9',
        text: ''
      },
      3: {
        color: '#00a5a9',
        text: ''
      },
      4: {
        color: '#00a5a9',
        text: ''
      }
    };

    var strength = _extends({}, defaultStrength, this.props.strength);

    var result = zxcvbn(this.props.password);

    // Update the text indicator
    if (this.props.password !== '') {
      this.setState({
        color: strength[result.score].color,
        text: strength[result.score].text,
        warning: result.feedback.warning,
        score: result.score,
        suggestions: result.feedback.suggestions
      });
    } else {
      this.setState({
        color: '',
        resultScore: '',
        warning: '',
        suggestions: '',
        score: ''
      });
    }
  };

  PasswordStrength.prototype.render = function render() {
    var scoreMeterPercentage = (this.state.score + 1) / 5 * 100;
    var defaultStyles = {
      container: {},
      meterContainer: {
        backgroundColor: '#ccc',
        overflow: 'hidden',
        position: 'relative',
        height: '2px',
        width: '100%'
      },
      meterIndicator: {
        backgroundColor: this.state.color,
        height: '100%',
        left: '-100%',
        position: 'absolute',
        top: 0,
        width: '100%',
        transitionProperties: 'background-color, transform',
        transitionDuration: '.4s',
        transitionTimingFunction: 'ease-in-out',
        transform: 'translate3d(' + scoreMeterPercentage + '%, 0, 0)'
      },
      text: {
        transitionProperties: 'color',
        transitionDuration: '.4s',
        transitionTimingFunction: 'ease-in'
      },
      bar: {}
    };

    return React.createElement(
      'div',
      {
        style: _extends({}, defaultStyles.container, this.props.styles.container)
      },
      React.createElement(
        'div',
        {
          style: _extends({}, defaultStyles.meterContainer, this.props.styles.meterContainer)
        },
        React.createElement('div', {
          style: _extends({}, defaultStyles.meterIndicator, this.props.styles.meterIndicator)
        })
      ),
      this.state.text && React.createElement(
        'div',
        {
          style: _extends({ color: this.state.color }, defaultStyles.text, this.props.styles.text)
        },
        this.state.score && this.state.text
      )
    );
  };

  return PasswordStrength;
}(React.Component);

PasswordStrength.defaultProps = {
  styles: {
    container: {},
    meterContainer: {},
    meterIndicator: {},
    text: {}
  }
};

PasswordStrength.propTypes = process.env.NODE_ENV !== "production" ? {
  password: PropTypes.string.isRequired,
  styles: PropTypes.object
} : {};


//////////////////
// WEBPACK FOOTER
// ../ui-components/es/PasswordStrength.js
// module id = 312
// module chunks = 4